<template>
  <div>
    <p class="text-left margin-halfem">絞り込む</p>
    <div class="srv-tags">
      <button
        v-for="tag in tags"
        @click="handleUpdate(tag.value)"
        :class="{ 'is-active': tag.value === (activeTag ? activeTag : '') }"
      >
        {{ tag.label }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Tags',
  props: ['updateFilter', 'tags', 'activeTag'],
  methods: {
    handleUpdate(value) {
      this.updateFilter({ tag: value });
    }
  }
};
</script>

<style scoped>
.srv-tags button {
  margin-right: 0.5em;
  padding: 0.5em 1em;
  border-radius: 1.1em;
  background-color: #d6cecc;
  color: inherit;
  line-height: 1.2;
  cursor: pointer;
  transition: color 0.25s, background-color 0.25s;
}

.srv-tags button:focus,
.srv-tags button:active {
  outline: none;
}

.srv-tags button.is-active {
  background-color: #6a625f;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/tags.vue